import { createRouter, createWebHistory } from 'vue-router';
import API from '@/services/address';
import { postRequest } from '@/services/apiService';

const routes = [
  {
    path: '/forget-password',
    name: 'ForgetPassword',
    component: () => import('@/components/users/ForgetPassword.vue'),
    meta: { requiresGuest: true }
  },
  {
    path: '/login',
    name: 'LoginAndRegist',
    component: () => import('@/components/users/LoginAndRegist.vue'),
    meta: { requiresGuest: true }
  },
  {
    path: '/token-bridge',
    name: 'TokenBridge',
    component: () => import('@/components/TokenBridge.vue'),
    meta: { requiresGuest: true }
  },
  {
    path: '/',
    name: 'Welcome',
    component: () => import('@/components/Welcome.vue'),
    meta: { requiresGuest: true }
  },
  {
    path: '/r/:code',
    name: 'PromotionRedirect',
    component: () => import('@/components/PromotionRedirect.vue'),
    meta: { requiresGuest: true }
  },
  {
    path: '/main',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/HomePage.vue'),
    meta: {
      title: '首页 - BinGo408',
      requiresAuth: true
    }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('@/views/ProfilePage.vue'),
    meta: {
      title: '个人信息 - BinGo408',
      requiresAuth: true
    }
  },
  {
    path: '/chapters/:bookId',
    name: 'Chapters',
    component: () => import('@/views/ChaptersPage.vue'),
    meta: {
      title: '章节列表 - BinGo408',
      requiresAuth: true
    }
  },
  {
    path: '/learning/:knowledgeModelId',
    name: 'Learning',
    component: () => import('@/views/LearningPage.vue'),
    meta: {
      title: '学习内容 - BinGo408',
      requiresAuth: true
    }
  },
  {
    path: '/notes/:bookId',
    name: 'Notes',
    component: () => import('@/views/NotesPage.vue'),
    meta: {
      title: '我的笔记 - BinGo408',
      requiresAuth: true
    }
  },
  {
    path: '/flash-exampoint/:bookId',
    name: 'FlashExampoint',
    component: () => import('@/views/FlashcardPage.vue'),
    meta: {
      title: '闪卡知识点 - BinGo408',
      requiresAuth: true
    }
  },
  // 论坛相关路由
  {
    path: '/forum',
    name: 'Forum',
    redirect: '/forum/index',
    meta: {
      title: '论坛 - BinGo408',
      requiresAuth: true
    }
  },
  {
    path: '/forum/index',
    name: 'ForumIndex',
    component: () => import('@/views/forum/ForumIndex.vue'),
    meta: {
      title: '论坛首页 - BinGo408',
      requiresAuth: true
    }
  },
  {
    path: '/forum/post/:id',
    name: 'PostDetail',
    component: () => import('@/views/forum/PostDetail.vue'),
    meta: {
      title: '帖子详情 - BinGo408',
      requiresAuth: true
    }
  },
  {
    path: '/forum/create',
    name: 'CreatePost',
    component: () => import('@/views/forum/CreatePost.vue'),
    meta: {
      title: '发帖 - BinGo408',
      requiresAuth: true
    }
  },
  {
    path: '/forum/category/:type',
    name: 'ForumCategory',
    component: () => import('@/views/forum/ForumIndex.vue'),
    meta: {
      title: '论坛分类 - BinGo408',
      requiresAuth: true
    }
  },
  {
    path: '/development',
    name: 'Development',
    component: () => import('@/views/forum/DevelopmentPage.vue'),
    meta: {
      title: '开发计划 - BinGo408',
      requiresAuth: true
    }
  },
  {
    path: '/forum/development/:id',
    name: 'DevelopmentDetail',
    component: () => import('@/views/forum/DevelopmentDetail.vue'),
    meta: {
      title: '计划详情 - BinGo408',
      requiresAuth: true
    }
  },
  // 消息中心路由
  {
    path: '/messages',
    name: 'Messages',
    component: () => import('@/views/MessagePage.vue'),
    meta: {
      title: '消息中心 - BinGo408',
      requiresAuth: true
    }
  },
  {
    path: '/flashcards',
    name: 'Flashcards',
    component: () => import('@/views/FlashcardPage.vue'),
    meta: {
      title: '闪卡 - BinGo408',
      requiresAuth: true
    }
  },
  {
    path: '/mind-map',
    name: 'MindMap',
    component: () => import('@/views/MindMapPage.vue'),
    meta: {
      title: '导图 - BinGo408',
      requiresAuth: true
    }
  },
  {
    path: '/usage-guide',
    name: 'UsageGuide',
    component: () => import('@/views/UsageGuidePage.vue'),
    meta: {
      title: '使用说明 - BinGo408',
      requiresAuth: false
    }
  },
  // 任务中心路由
  {
    path: '/task',
    name: 'TaskCenter',
    component: () => import('@/views/TaskCenter.vue'),
    meta: {
      title: '任务中心 - BinGo408',
      requiresAuth: true
    }
  },
  {
    path: '/task/collection/create',
    name: 'CreateTaskCollection',
    component: () => import('@/views/CreateTaskCollection.vue'),
    meta: {
      title: '创建任务合集 - BinGo408',
      requiresAuth: true
    }
  },
  // 心仪学校选择路由
  {
    path: '/school-select',
    name: 'SchoolSelect',
    component: () => import('@/views/SchoolSelectPage.vue'),
    meta: {
      title: '选择心仪学校 - BinGo408',
      requiresAuth: true
    }
  },
  // 购买/解锁页面
  {
    path: '/purchase',
    name: 'Purchase',
    component: () => import('@/components/Purchase.vue'),
    meta: {
      title: '解锁书籍 - BinGo408',
      requiresAuth: true
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/components/NotFound.vue'),
    meta: {
      title: '页面未找到 - BinGo408'
    }
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

// Token 验证缓存（避免重复请求）
let tokenValidationCache = {
  isValid: false,
  lastCheck: 0,
  checking: false
};

// Token 验证函数
async function validateToken() {
  const userToken = localStorage.getItem("authToken");
  const lastValidationTime = localStorage.getItem("lastTokenValidation");
  const validationInterval = 30 * 60 * 1000; // 30分钟缓存

  // 无 token
  if (!userToken) {
    return { valid: false, reason: 'no_token' };
  }

  // 使用缓存（30分钟内）
  const now = Date.now();
  if (lastValidationTime && (now - parseInt(lastValidationTime) < validationInterval)) {
    console.log('[路由守卫] 使用缓存的token验证结果');
    return { valid: true, reason: 'cached' };
  }

  // 避免并发验证
  if (tokenValidationCache.checking) {
    console.log('[路由守卫] Token验证进行中，等待结果...');
    await new Promise(resolve => setTimeout(resolve, 100));
    return tokenValidationCache.isValid ? { valid: true } : { valid: false, reason: 'checking' };
  }

  // 发起验证请求
  try {
    tokenValidationCache.checking = true;
    console.log('[路由守卫] 验证Token...');

    const response = await postRequest(API.valToken, {});

    if (response.success) {
      // 更新缓存和本地存储
      localStorage.setItem("lastTokenValidation", now.toString());
      localStorage.setItem("user", JSON.stringify(response.data));
      localStorage.setItem("authToken", response.data.userToken);
      tokenValidationCache.isValid = true;
      tokenValidationCache.lastCheck = now;
      return { valid: true, reason: 'verified' };
    } else {
      console.log('[路由守卫] Token验证失败:', response.message);
      clearAuthState();
      return { valid: false, reason: 'invalid' };
    }
  } catch (error) {
    console.error('[路由守卫] Token验证出错:', error);
    // 特殊处理：用户需要验证（如二次验证）
    if (error.response?.status === 403 && error.response?.data?.message === '用户需要验证') {
      return { valid: false, reason: 'needs_verification' };
    }
    clearAuthState();
    return { valid: false, reason: 'error' };
  } finally {
    tokenValidationCache.checking = false;
  }
}

// 清除认证状态
function clearAuthState() {
  localStorage.removeItem('authToken');
  localStorage.removeItem('user');
  localStorage.removeItem('lastTokenValidation');
  tokenValidationCache.isValid = false;
}

// 全局路由守卫 - 处理认证和页面标题
router.beforeEach(async (to, from, next) => {
  console.log('[路由守卫] 导航到:', to.path, '来自:', from.path);

  // 设置页面标题
  document.title = to.meta.title || 'BinGo408 - 必过408计算机专业课考研刷题软件';

  // 访客页面（首页、登录页、推广页）- 特殊处理
  if (to.meta.requiresGuest) {
    // 如果是首页或登录页，且用户已登录，则跳转到主页
    if ((to.path === '/' || to.path === '/login') && localStorage.getItem('authToken')) {
      console.log('[路由守卫] 已登录用户访问访客页面，验证token...');
      const validation = await validateToken();

      if (validation.valid) {
        console.log('[路由守卫] Token有效，重定向到主页');
        next({ path: '/home', replace: true });
        return;
      } else {
        console.log('[路由守卫] Token无效，允许访问访客页面');
        next();
        return;
      }
    }

    // 推广页等其他访客页面直接放行
    console.log('[路由守卫] 访客页面，允许访问');
    next();
    return;
  }

  // 检查是否为公共页面（明确设置 requiresAuth: false）
  if (to.meta.requiresAuth === false) {
    console.log('[路由守卫] 公共页面，允许访问');
    next();
    return;
  }

  // 其他页面需要认证
  const validation = await validateToken();

  if (validation.valid) {
    console.log('[路由守卫] Token有效，允许访问');
    next();
  } else {
    console.log('[路由守卫] 自动登录失败，原因:', validation.reason);

    // 保存目标路径，登录后可以跳转回来
    if (to.path !== '/' && to.path !== '/login') {
      localStorage.setItem('lastPath', to.path);
      console.log('[路由守卫] 已保存目标路径:', to.path);
    }

    // 跳转到登录页（而不是首页）
    console.log('[路由守卫] 重定向到登录页');
    next({ path: '/login', replace: true }); // 使用 replace 避免产生历史记录
  }
});

export default router;
